import * as getJSON from './getJSON';
import Mustache from 'mustache';
function blogPosts() {
String.fromHtmlEntities = function (string) {
  return (string + "").replace(/&#\d+;/gm, function (s) {
    return String.fromCharCode(s.match(/\d+/gm)[0]);
  })
};

getJSON.loadJSON('https://apps.library.vcu.edu/pub_scripts/blog-headlines/librarycollections.json',
  data => {
    $.get('https://apps.library.vcu.edu/pub_scripts/js/templates/from-blogs.html', function (template) {
      for (var i = 0, title;
        (title = data[i]); ++i) {
        data[i].title.rendered = String.fromHtmlEntities(data[i].title.rendered)
      }
      var story = $('.discovery--blogs > li:nth-child(3)');
      var rendered = Mustache.render(template, {
        "posts": data
      });
      story.append(rendered);
    })
  });
}

export function getBlogs() {
  blogPosts();
}